import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");

    if (!session_id) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await exchangeSession(session_id);
        setUser(user);
        // Hand off the user object via location.state so ProtectedRoute
        // can render immediately without depending on cookie/state timing.
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        const msg =
          e?.response?.data?.detail ||
          "Login gagal. Hanya admin yang diizinkan mengakses panel ini.";
        setError(msg);
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#060a1a] text-slate-300 px-6" data-testid="auth-callback-page">
      <div className="text-center max-w-md">
        {error ? (
          <>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-400/30 text-red-300 text-[11px] uppercase tracking-[0.22em] font-mono-display">
              login error
            </div>
            <p className="mt-4 text-base text-white" style={{ fontFamily: "Outfit" }}>
              {error}
            </p>
            <p className="mt-2 text-xs text-slate-500">Mengarahkan kembali ke login…</p>
          </>
        ) : (
          <>
            <div className="inline-flex items-center gap-3 text-sm font-mono-display text-slate-300">
              <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
              <span>menyiapkan session…</span>
            </div>
            <p className="mt-3 text-xs text-slate-500">Mohon tunggu sebentar.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
